/* tslint:disable:no-console */
import {Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {timer, zip} from 'rxjs';
import {Page, PortalApiService, SearchCriteria} from '../../modules/record/portal-api.service';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {CoreService, LookupLists} from "../../modules/core.service";
import {StockItemSearchResult, StockItemSelector} from "../../modules/record/feature-print-models";
import {BaseService} from "../../modules/base/base.service";
import {IdWithIndex} from "../../modules/base/base.module";

@Component({
  selector: 'ae-featureprint-list',
  templateUrl: './featureprint-list.component.html',
  styleUrls: ['./featureprint-list.component.scss']
})
export class FeatureprintListComponent implements OnInit {
  lookups: LookupLists = new LookupLists([]);
  datasetNames: string[] = [];
  currentStockItem: string | null = null;
  searchDataset: string | null = null;
  selectedStockItem: StockItemSelector | null = null;

  searchError = false;
  searchCriteria!: SearchCriteria;
  stockItems: StockItemSearchResult[] | null = null;
  searchResultsTotal = 0;
  //pageIndex = 0;
  pageSize = 20;
  pageSizeOptions = [5, 10, 15, 20, 25, 50];
  @ViewChild('paginator')
  paginator!: MatPaginator;
  @ViewChild('stockItemTop')
  regTopElement!: ElementRef;
  @ViewChildren('stockItemList')
  regListElements!: QueryList<ElementRef>;

  customer = "";

  constructor(private recordApi: PortalApiService, private coreSvc: CoreService, private baseSvc: BaseService) {
  }

  ngOnInit(): void {
    this.customer = this.baseSvc.appConfig().customerName;

    this.coreSvc.getLookupLists().subscribe(lookups => {
      this.lookups = lookups;
      this.datasetNames = this.lookups.dataSets.map(dsRole => dsRole.name);
    });
  }

  public resetSearchHandler() {
    //this.pageIndex = 0;
    this.stockItems = null;
    this.searchResultsTotal = 0;
    this.currentStockItem = null;
    this.selectedStockItem = null;
  }

  public searchHandler(searchCriteria: SearchCriteria): void {
    this.stockItems = null;
    this.currentStockItem = null;
    this.searchCriteria = searchCriteria;
    this.doSearch(true);
  }

  doSearch(resetPage = false): void {
    if (this.searchCriteria) {
      if(resetPage) {
        this.paginator?.firstPage();
      }
      this.searchCriteria.page = new Page(this.paginator?.pageIndex || 0, this.pageSize);
      const searchStream = this.recordApi.searchStockItems(this.searchCriteria);
      const countStream = this.recordApi.featurePrintSearchCount(this.searchCriteria);
      zip(searchStream, countStream).subscribe({
        next: ([records, cnt]) => {
          this.searchError = false;
          this.stockItems = records;
          this.searchResultsTotal = cnt;
          this.searchDataset = this.searchCriteria.dataset;
        },
        error: errors => {
          this.searchError = true;
          this.searchResultsTotal = 0;
          this.stockItems = [];
          console.error('error searching registrations', errors);
        }
      });
    }
  }

  pageHandler(event: PageEvent): void {
    this.currentStockItem = null;
    this.pageSize = this.paginator.pageSize;
    this.doSearch();
  }

  registrationChangeHandler(event: string): void {
    this.doSearch();
  }

  stockItemChangeHandler(event: IdWithIndex): void {
    this.currentStockItem == event.id ? this.clearCurrent() : this.viewCapture(event.index, event.id);
  }

  @Input('searchResults') set searchResults(list: StockItemSearchResult[]) {
    if (list) {
      this.stockItems = list;
      if (this.stockItems.length > 0) {
        this.selectTopOfList();
      } else {
        this.currentStockItem = null;
      }
    }
  }

  protected clearCurrent(): void {
    console.log("clear selected");
    this.currentStockItem = null;
    this.selectedStockItem = null;
  }

  protected viewCaptureAndScroll(id: string, i: number, scroll: boolean): void {
    this.currentStockItem = id;
    this.selectedStockItem = {stockItemId: id, dataset: this.searchDataset!};
    if (scroll && id) {
      timer(50).subscribe(() => {
        this.regListElements.toArray()[i].nativeElement.scrollIntoViewIfNeeded({behavior: 'auto'});
        timer(250).subscribe(() => {
          this.regTopElement.nativeElement.scrollIntoViewIfNeeded({behavior: 'smooth'});
        });
      });
    }
  }

  protected viewCapture(i: number, id?: string): void {
    if (!id) {
      return;
    }
    const doScroll: boolean = this.currentStockItem ? false : true;
    this.viewCaptureAndScroll(id, i, doScroll);
  }

  private selectTopOfList(): void {
    if (!this.stockItems || this.stockItems.length === 0) {
      return;
    }

    const list = this.stockItems;

    if (list.length > 0) {
      let index = 0;
      if (this.currentStockItem) {
        index = list.findIndex(r => r.stockItemId == this.currentStockItem);
        index = index < 0 ? 0 : index;
      }
      this.viewCaptureAndScroll(list[index]?.stockItemId, index, true);
    } else {
      this.clearCurrent();
    }
  }
}
